import * as actionTypes from "../actionTypes";
import * as ImmersionGQL from "../../../gql";
import {IProject} from "../../reducers/creator/creatorDashboard";

const setLoading = (loading: boolean) => ({
  type: actionTypes.SET_LOADING,
  payload: loading
});

const getProjectListSuccess = (projects: IProject[]) => ({
  type: actionTypes.GET_PROJECTS_SUCCESS,
  payload: projects
});

const addProjectSuccess = (project: IProject) => ({
  type: actionTypes.ADD_PROJECT_SUCCESS,
  payload: project
});

const updateProjectSuccess = (project: any, index: number) => ({
  type: actionTypes.UPDATE_PROJECT_SUCCESS,
  payload: {
    project,
    index
  }
});

const deleteProjectSuccess = (index: number) => ({
  type: actionTypes.DELETE_PROJECT_SUCCESS,
  payload: index
});

export const updateProjects = (value: any) => ({
  type: actionTypes.UPDATE_PROJECTS,
  payload: value
});

const sortProjectsByOrder = (projects: IProject[]) => {
  // sort ascending
  projects.sort((a, b) => {
    return a.cascadedProjectOrder - b.cascadedProjectOrder
  });
  return projects
};

// const addProjectToExperienceSuccess = (res: any) => ({
//   type: actionTypes.ADD_PROJECT_TO_EXPERIENCE_SUCCESS,
//   payload: res
// });

export const initAlertStatus = () => ({
  type: actionTypes.INIT_ALERT_STATUS
});

// get projects list
export const getProjects = (client: any, req: any) => {
  return (dispatch: any) => {
    const variables = {...req};
    dispatch(setLoading(true));
    client.query({
      query: ImmersionGQL.queryViewProject,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data.viewProject) {
        const filterProjects = res.data['viewProject'].filter((project: IProject) => !project.deleted);
        const projects = sortProjectsByOrder(filterProjects);
        dispatch(getProjectListSuccess(projects));
      }
      dispatch(setLoading(false));
    }).catch(() => {
      dispatch(getProjectListSuccess([]));
      dispatch(setLoading(false));
    })
  }
};

// create a project
export const createProject = (client: any, req: any, cb?:any) => {
  return (dispatch: any) => {
    const variables = {...req};
    dispatch(setLoading(true));
    client.mutate({
      mutation: ImmersionGQL.mutationAddProject,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data.addProject) {
        dispatch(addProjectSuccess(res.data.addProject));
		cb && cb(res.data.addProject)
		dispatch(setLoading(false));
      } else {
		cb && cb(null)
		dispatch(setLoading(false));
	  }
    }).catch(() => {
      // handle error
      dispatch(setLoading(false));
	  cb && cb(null)
    })
  }
};

// update project
export const updateProject = (client: any, req: any, index: number) => {
  return (dispatch: any) => {
    const variables = {...req};
    dispatch(setLoading(true));
    client.mutate({
      mutation: ImmersionGQL.mutationUpdateProject,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data['updateProject']) {
        dispatch(updateProjectSuccess(res.data['updateProject'], index))
      }
      dispatch(setLoading(false));
    }).catch(() => {
      // handle error
      dispatch(setLoading(false));
    })
  }
};

// delete project
export const deleteProject = (client: any, req: any, index: number) => {
  return (dispatch: any) => {
    const variables = {...req};
    dispatch(setLoading(true));
    client.mutate({
      mutation: ImmersionGQL.mutationDeleteProject,
      fetchPolicy: "no-cache",
      variables
    }).then((res: any) => {
      if (res.data['deleteProject'] && res.data['deleteProject'].status === true) {
        dispatch(deleteProjectSuccess(index));
      }
      dispatch(setLoading(false));
    }).catch(() => {
      // handle error
      dispatch(setLoading(false));
    })
  }
};

export const onSendEmailForContactUs = (client: any, request: any, callback: any) => {
  return () => {
    client.query({
      query: ImmersionGQL.querySendEmailTemplate,
      fetchPolicy: "no-cache",
      variables: {
        template_type: "onboarding_support",
        objectData: request
      }
    }).then((res: any) => {
      if (res.data.sendEmailTemplate.status) {
        callback(true)
      } else {
        callback(false);
      }
    }).catch(() => {
      callback(false);
    })
  }
};

// // add Project To Experience
// export const addProjectToExperience = (client: any, req: any) => {
//   return (dispatch: any) => {
//     const variables = {...req};
//     dispatch(setLoading(true));
//     client.mutate({
//       mutation: ImmersionGQL.mutationAddProjectToExperience,
//       fetchPolicy: "no-cache",
//       variables
//     }).then((res: any) => {

//       if (res.data['addProjectToExperience']) {
//         dispatch(addProjectToExperienceSuccess(res.data['addProjectToExperience']))
//       }
//       dispatch(setLoading(false));
//     }).catch(() => {
//       // handle error
//       dispatch(setLoading(false));
//     })
//   }
// };

// // remove  Experiences from projects
// export const removeExperienceFromProject = (client: any, req: any) => {
//   return (dispatch: any) => {
//     const variables = {...req};
//     dispatch(setLoading(true));
//     client.mutate({
//       mutation: ImmersionGQL.mutationRemoveExperienceFromProject,
//       fetchPolicy: "no-cache",
//       variables
//     }).then((res: any) => {
//       if (res.data['removeExperienceFromProject']) {
//         dispatch(addProjectToExperienceSuccess(res.data['removeExperienceFromProject']))
//       }
//       dispatch(setLoading(false));
//     }).catch(() => {
//       // handle error
//       dispatch(setLoading(false));
//     })
//   }
// };